import React, {useMemo} from 'react';
import {ThemeProvider} from '@mui/material/styles';
import {getMuiFormsTheme} from 'styles/MuiFormsTheme';
import {useTheme} from 'styles/ThemeContext';
import styled from 'styled-components';

import MuiForm from 'components/MuiForm';

export default function Address({
  schema,
  onSubmit,
  heading = 'Address',
  subHeading = 'Please fill your foreign address',
  isLoading = false,
}) {
  const {themes, currentTheme} = useTheme();
  const muiTheme = useMemo(() => getMuiFormsTheme(themes[currentTheme]), [themes, currentTheme]);

  return (
    <ThemeProvider theme={muiTheme}>
      <FormWrapper>
        <MuiForm schema={schema} onSubmit={onSubmit} />
      </FormWrapper>
    </ThemeProvider>
  );
}

const FormWrapper = styled.div`
  height: 100%;
  padding: 1.5rem 1rem 1rem 1rem;
  @media screen and (max-width: 768px) {
    padding: 0;
  }
`;
